var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.451,
    height: 31.45,
    viewBox: "0 0 31.451 31.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-sent_1_",
    "data-name": "icons8-sent (1)",
    d: "M5.136,4a1.18,1.18,0,0,0-1.05,1.622L9.8,19.725l-5.717,14.1a1.18,1.18,0,0,0,1.62,1.5L34.8,20.78a1.18,1.18,0,0,0,0-2.11L5.706,4.125A1.18,1.18,0,0,0,5.136,4Zm2.31,3.63L31.634,19.725,7.446,31.819,11.872,20.9H22.477a1.179,1.179,0,1,0,0-2.359H11.872Z",
    transform: "translate(-3.999 -4.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.a4d73215e4d8df3f19d07f5282e4f83c.svg";
export { ForwardRef as ReactComponent };